import React from "react";
import { Box, IconButton, Paper, Tooltip, Typography } from "@mui/material";
import ArchiveOutlined from "@mui/icons-material/ArchiveOutlined";
import DeleteOutline from "@mui/icons-material/DeleteOutline";
import MarkEmailReadOutlined from "@mui/icons-material/MarkEmailReadOutlined";
import MarkEmailUnreadOutlined from "@mui/icons-material/MarkEmailUnreadOutlined";
import UnarchiveOutlined from "@mui/icons-material/UnarchiveOutlined";

const PREVIEW_LEN = 160;

function previewText(text) {
  if (!text || typeof text !== "string") return "";
  const t = text.trim();
  if (t.length <= PREVIEW_LEN) return t;
  return `${t.slice(0, PREVIEW_LEN).trimEnd()}...`;
}

const iconBtnSx = { p: 0.75 };

function TooltipIconButton({ title, children }) {
  return (
    <Tooltip title={title} placement="top" arrow>
      <Box component="span" sx={{ display: "inline-flex", verticalAlign: "middle" }}>
        {children}
      </Box>
    </Tooltip>
  );
}

const CardNotifica = ({
  notification,
  variant,
  onOpen,
  onToggleRead,
  onArchive,
  onDelete,
  onRestore,
  readOnly = false,
}) => {
  const isArchived = variant === "archived";
  const unread = !notification.isRead && !isArchived;

  return (
    <Paper
      elevation={0}
      onClick={() => onOpen(notification)}
      sx={{
        p: 2,
        borderRadius: 2,
        border: "1px solid #e0e0e0",
        borderLeft: unread ? "4px solid #0b3d87" : "1px solid #e0e0e0",
        backgroundColor: unread ? "#f7f9fc" : "#fff",
        cursor: "pointer",
        transition: "box-shadow 0.2s ease",
        "&:hover": {
          boxShadow: 2,
        },
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="flex-start" gap={2}>
        <Box flex={1} minWidth={0}>
          <Typography
            sx={{
              fontFamily: "Rubik",
              fontSize: 12,
              color: "#808080",
              mb: 0.5,
            }}
          >
            {notification.date}
          </Typography>
          <Typography
            sx={{
              fontFamily: "Rubik",
              fontWeight: unread ? "bold" : "normal",
              color: "#0b3d87",
              fontSize: 16,
              mb: 1,
              wordBreak: "break-word",
            }}
          >
            {notification.title}
          </Typography>
          <Typography
            sx={{
              fontFamily: "Rubik",
              color: "#4a4a4a",
              fontSize: 14,
              fontWeight: unread ? "bold" : 400,
              lineHeight: 1.45,
              display: "-webkit-box",
              WebkitLineClamp: 3,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
          >
            {previewText(notification.description)}
          </Typography>
        </Box>

        <Box
          display="flex"
          alignItems="center"
          gap={0.5}
          flexShrink={0}
          onClick={(e) => e.stopPropagation()}
        >
          {isArchived ? (
            <>
              <TooltipIconButton title="Ripristina la notifica nell'elenco principale">
                <IconButton
                  size="small"
                  aria-label="Ripristina notifica"
                  sx={iconBtnSx}
                  disabled={readOnly}
                  onClick={() => onRestore(notification.id)}
                >
                  <UnarchiveOutlined sx={{ color: "#0b3d87" }} />
                </IconButton>
              </TooltipIconButton>
              <TooltipIconButton title="Elimina definitivamente la notifica">
                <IconButton
                  size="small"
                  aria-label="Elimina notifica"
                  sx={iconBtnSx}
                  disabled={readOnly}
                  onClick={() => onDelete(notification.id)}
                >
                  <DeleteOutline sx={{ color: "#e00036" }} />
                </IconButton>
              </TooltipIconButton>
            </>
          ) : (
            <>
              <TooltipIconButton
                title={notification.isRead ? "Segna come non letta" : "Segna come letta"}
              >
                <IconButton
                  size="small"
                  aria-label={notification.isRead ? "Segna come non letta" : "Segna come letta"}
                  sx={iconBtnSx}
                  disabled={readOnly}
                  onClick={() => onToggleRead(notification.id)}
                >
                  {notification.isRead ? (
                    <MarkEmailUnreadOutlined sx={{ color: "#0b3d87" }} />
                  ) : (
                    <MarkEmailReadOutlined sx={{ color: "#0b3d87" }} />
                  )}
                </IconButton>
              </TooltipIconButton>
              <TooltipIconButton title="Archivia la notifica">
                <IconButton
                  size="small"
                  aria-label="Archivia notifica"
                  sx={iconBtnSx}
                  disabled={readOnly}
                  onClick={() => onArchive(notification.id)}
                >
                  <ArchiveOutlined sx={{ color: "#ed6c02" }} />
                </IconButton>
              </TooltipIconButton>
              <TooltipIconButton title="Elimina definitivamente la notifica">
                <IconButton
                  size="small"
                  aria-label="Elimina notifica"
                  sx={iconBtnSx}
                  disabled={readOnly}
                  onClick={() => onDelete(notification.id)}
                >
                  <DeleteOutline sx={{ color: "#e00036" }} />
                </IconButton>
              </TooltipIconButton>
            </>
          )}
        </Box>
      </Box>
    </Paper>
  );
};

export default CardNotifica;
